import React , { useEffect }from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";

const JobDetailPage2 = () => {

 useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);
          const navigate = useNavigate();

  return (
    <Box>
      {/* Header Section */}
      <Box>
 
  <Box
    sx={{
      background: "radial-gradient(circle, #1F6788,#161623)",
      color: "white",
      py: 15, // Increased vertical padding to make it taller
      px: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    }}
  >
    <Typography variant="h3" fontWeight="bold" mb={3}>
    Sales and Marketing Executive
    </Typography>

    <Button
      variant="contained"
      sx={{
        backgroundColor: "white",
        color: "#1F6788",
        fontWeight: 600,
        px: 4,
        py: 1.5,
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      }}
      onClick={() => navigate("/contact")}
    >
      Apply now
    </Button>
  </Box>
</Box>


     {/* Main Content */}
<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center", // vertically aligns if needed
    px: 2,
    py: 10,
    width: "100%",
  // backgroundColor: "#B2EBF2" ,
   backgroundColor:"#B0E0E6",
  }}
>
  <Box
    sx={{
      p: { xs: 2, md: 6 },
      maxWidth: "1200px", // limits content width for large screens
      width: "100%", // full width for responsiveness
    }}
  >
    <Grid container spacing={4}>
      {/* Left Side - Job details */}
      <Grid item xs={12} md={4}>
        <Typography variant="body1" fontWeight="bold">Job details</Typography>
        <Typography mt={2}><strong>Work Location</strong><br />Remote</Typography>
        <Typography mt={2}><strong>Country</strong><br />India</Typography>
        <Typography mt={2}><strong>Company</strong><br />Tech Informatic Solutions</Typography>
      </Grid>

      {/* Right Side - Job Description */}
      <Grid item xs={12} md={8}>
        <Typography  variant="h6" fontWeight="bold">Job Description</Typography>

        <Box mt={2}>
          <Typography variant="body2" lineHeight={1.5} mb={2}><strong>Role –</strong> Sales and Marketing Executive</Typography>
          <Typography variant="body2" lineHeight={1.5} mb={2}><strong>Location –</strong> Remote, India</Typography>
        </Box>

        <Box mt={3}>
         
  {/* Requirements */}
          <Typography variant="h6" fontWeight="bold" mb={2}>Requirements</Typography>
          {[
            "Bachelor’s degree in marketing, business, or related field.",
            "Proven work experience as a sales and marketing executive.",
            "Knowledge of modern marketing techniques.",
            "High-level communication and networking skills.",
            "Proficiency in HTML, CSS, and JavaScript.",
            "A passion for sales.",
            "Understanding of commercial trends and marketing strategies.",
            "Excellent interpersonal skills.",
            "A passion for sales.",
            "Ability to work well under pressure."
            
          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}
        

          {/* Responsibilities */}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>Responsibilities</Typography>
          {[
            "Contributing to the development of marketing strategies.",
            "Conducting market research on rival products.",
            "Designing and implementing marketing plans for company products.",
            "Coordinating with media representatives and sponsors.",
            " Working with the sales team to develop targeted sales strategies.",
            "Answering client queries about product specifications and uses."

         


          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}

          {/* Must Have */}
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>Maintaining client relations</Typography>
          {[
           "Tracking sales data to ensure the company meets sales quotas.",
  "Creating and presenting sales performance reports.",
  

          ].map((text, index) => (
            <Typography key={index} variant="body2" lineHeight={1.7} mb={1}>{text}</Typography>
          ))}

          

          
          <Typography variant="h6" fontWeight="bold" mt={4} mb={2}></Typography>
          {[
            "All aspects of employment at Tech Informatic Solutions are based on merit, competence and performance. We are committed to embracing diversity and creating an inclusive environment for all employees. TIS is proud to be an equal opportunity employer",
            
          ].map((text, index) => (
            <Typography key={index} variant="body2"  fontWeight="bold" lineHeight={1.7} mb={1}>{text}</Typography>



            
          ))}



    {/* Bottom Buttons */}
    <Box mt={5} display="flex" gap={2}>
      <Button variant="contained" sx={{ backgroundColor: '#1F6788' }}  onClick={() => navigate("/contact")}>Apply now</Button>
      
    </Box>



        </Box>
      </Grid>
    </Grid>

  </Box>
</Box>

    </Box>
  );
};

export default JobDetailPage2;
